import Agreement from 'components/Agreement';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import './index.less';

const UserInfo: FC = (props) => {
  const userInfo = useSelector((state) => state.global.userInfo);
  return (
    <>
      {userInfo && (
        <>
          {props.children}
          <Agreement />
        </>
      )}
    </>
  );
};

export default UserInfo;
